<template>
  <kab-content>
    <template #section-title>
      Apprentices
    </template>
    <template #section-body>
      <div class="md-layout">
        <template v-for="(item, index) in apprentices">
          <apprentices-list
            :id="index"
            :key="index"
            :title="item.title"
            :studio-name="item.field_studio"
            :body="item.body"
            :image="item.field_image"
            @selected="showDetails"
          />
        </template>
      </div>
      <md-dialog :md-active.sync="showDialog">
        <div class="md-layout kab-dialog">
          <apprentices-details
            :title="apprentice.title"
            :studio-name="apprentice.field_studio"
            :body="apprentice.body"
            :image="apprentice.field_image"
          />
        </div>
        <md-dialog-actions
          class="close-icon"
        >
          <i
            class="material-icons md-size-2x"
            @click="closeDialog"
          >
            clear
          </i>
        </md-dialog-actions>
      </md-dialog>
    </template>
  </kab-content>
</template>
<script>
import { mapState } from 'vuex'
import KabContent from '../components/KabContent'
import ApprenticesList from "@/components/Apprentices/ApprenticeList"
import ApprenticesDetails from "@/components/Apprentices/ApprenticesDetails"
export default {
  name: "Apprentices",
  components: {
    KabContent,
    ApprenticesList,
    ApprenticesDetails
  },
  data () {
    return {
      apprentice: {},
      showDialog: false
    }
  },
  computed: {
    ...mapState(['apprentices'])
  },
  async created () {
    this.getApprentices()
  },
  methods: {
    showDetails(index) {
      this.apprentice = this.apprentices[index]
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
    },
    async getApprentices() {
      const loader = this.$loading.show({
        container: null,
        canCancel: true,
      })
      try {
        await this.$store.dispatch('getApprentices')
        loader.hide()
      } catch (error) {
        loader.hide()
        throw Error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.md-dialog {
  border-radius: 7px !important;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
}
.kab-dialog {
  width: 60vw;
  overflow: scroll;
}
.close-icon {
  position: absolute;
  right: 0;
  margin-right: 10px;
  cursor: pointer;
  color: $color-primary;
}

@media only screen and (max-width: 600px) {
  .kab-dialog {
    width: 100vw;
  }
}

</style>